module.exports = __webpack_public_path__ + "static/img/homeBackground.c5e10ed6.jpg";